<template>

  <el-dialog
      title="认证"
      :visible.sync="visible"
      width="1200px"
      :before-close="handleClose">

    <div class="card-wrap flex-center-center fz24">
      <div
          v-if="isShowFace"
          class="tab-item"
          :class="activeName == '1' ? 'tab-item-active' : 'tab-item-inactive'"
          @click="onClickTab('1')"
      >
        法人认证
      </div>
      <div
          class="tab-item"
          :class="activeName == '0' ? 'tab-item-active' : 'tab-item-inactive'"
          @click="onClickTab('0')"
      >
        对公认证
      </div>
    </div>

    <div v-if="activeName == '1'" style="min-height: 450px">
      <div class="rechange-title">
        <img class="icon-rechange" src="@/assets/login/icon-rechange.png" alt/>
        注意：若刷脸失败，请尝试更换手机或刷脸APP，角度、光线也会影响刷脸结果
      </div>
      <div class="content flex" v-loading="loading">
        <div class="content-left">
          <div class="left-step">
            <div class="info-color">【步骤一】</div>
            <div class="fz14 flex-center">
              <img class="icon-step" src="@/assets/login/icon-step-down.png" alt/>
              <div>
                使用支付宝APP扫描右侧二维码
              </div>
            </div>
          </div>
          <div class="left-step">
            <div class="info-color">【步骤二】</div>
            <div class="fz14 flex-center">
              <img class="icon-step" src="@/assets/login/icon-step-scan.png" alt/>
              <div>
                刷脸过程中
                <span class="info-scan">请勿刷新页面</span>
              </div>
            </div>
          </div>
          <div class="left-step">
            <div class="info-color">【步骤三】</div>
            <div class="fz14 flex-center">
              <img class="icon-step" src="@/assets/login/icon-step-finish.png" alt/>
              <div>刷脸完成后，点击下方按钮《我已完成刷脸》刷新状态</div>
            </div>
          </div>
        </div>
        <div class="content-right">
          <img @click="getCode" class="img-code pointer" :src="codeUrl" alt/>
          <div class="info-color mt10 mb20 pointer" @click="showViewer">查看大图</div>
          <div>若二维码失效，手动点击二维码刷新</div>
        </div>
      </div>
    </div>

    <div v-if="activeName == '0'" style="min-height: 450px;margin-top: 35px">
      <div class="content" style="padding: 20px">
        <el-descriptions title="" :column="1">
          <el-descriptions-item label="企业名称">辽宁广烁科技有限公司</el-descriptions-item>
          <el-descriptions-item label="税号">91210204341167191F</el-descriptions-item>
          <el-descriptions-item label="开户银行">广发银行大连分行</el-descriptions-item>
          <el-descriptions-item label="银行账户">1330 1151 2010 0016 21</el-descriptions-item>
          <el-descriptions-item label="金额（元）">{{ money }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>


    <el-image-viewer
        style="z-index: 2022;"
        v-if="isShowPics"
        :on-close="closeViewer"
        :url-list="srcList"
    />

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button class="confirm-button" v-if="activeName == '1'" type="primary"
                 @click="onConfirm">我已完成刷脸</el-button>
      <el-button class="confirm-button" v-if="activeName == '0'" type="primary"
                 @click="handleConfirm">已打款</el-button>
    </span>
  </el-dialog>

</template>

<script>

export default {
  name: "identify",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ruleForm: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      activeName: "1",
      loading: false,
      codeUrl: '',
      checkId: '',
      isShowPics: false,
      srcList: [],

      isShowFace: true,
      money: null,
    };
  },
  created() {
    this.money = (Math.floor(Math.random() * 20) + 1) / 100
    let businessCreditCode = this.ruleForm.businessCreditCode
    let num = businessCreditCode.slice(2, 0 - (businessCreditCode.length - 4))
    if (num == '21') {
      this.getCode()
    } else {
      this.isShowFace = false
      this.activeName = '0'
    }
  },
  methods: {
    getBusinessList() {
      this.$http.get(this.$api.authentication.getBusinessList).then(res => {
        if (res.data.code == '200') {
          this.$auth.removeAccount()
          let accountData = res.data.data.onlineBusinesses
          accountData.unshift({
            name: res.data.data.onlineUser.name,
            type: 1
          })
          this.$auth.setAccount(JSON.stringify(accountData))
        }
      })
    },
    handleConfirm() {
      let params = {
        ...this.ruleForm,
        status: this.activeName
      };
      this.$http
          .post(this.$api.authentication.insertBusiness, params)
          .then(res => {
            if (res.data.code == 200) {
              this.getBusinessList()
              this.$message.success(this.activeName == '0' ? '认证中,请等待15-30个工作日' : '认证成功')
              this.$router.push({
                path: "/home",
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
    },
    onConfirm() {
      let params = {checkId: this.checkId};
      this.$http
          .post(this.$api.register.faceIdentityCheck, params)
          .then(res => {
            if (res.data.code == 200) {
              this.handleConfirm()
            } else {
              this.$message.error(res.data.msg);
            }
          });
    },
    showViewer() {
      this.isShowPics = true;
    },
    closeViewer() {
      this.isShowPics = false;
    },
    getCode() {
      let params = {
        businessCreditCode: this.ruleForm.businessCreditCode,
      };
      this.srcList = [];
      this.loading = true;
      this.$http.post(this.$api.register.initFace, params).then(res => {
        this.loading = false;
        if (res.data.code == 200) {
          this.codeUrl = "data:image/jpeg;base64," + res.data.data.QRCode;
          this.checkId = res.data.data.checkId;
          this.srcList.push(this.codeUrl);
        } else {
          this.isShowFace = false
          this.activeName = '0'
          this.$message.error(res.data.msg);
        }
      });
    },
    onClickTab(e) {
      this.activeName = e
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(() => {
            this.updateDialog(false)
          })
          .catch(() => {
          });
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-descriptions__body {
  background-color: #f5f7fa;
}

::v-deep .el-dialog__body {
  padding: 0 20px;
}

.box-card {
}

.apply-area {
  height: calc(100vh - 104px);
  padding: 20px 30px;
  min-height: 778px;
  background: #f5f7fa;
}

.tab-item {
  position: relative;
  margin: 0 45px;
  cursor: pointer;
}

.tab-item-active {
  color: #407fff;

  &:after {
    position: absolute;
    content: "";
    width: 32px;
    height: 2px;
    background-color: #407fff;
    left: 50%;
    bottom: -19px;
    margin-left: -16px;
  }
}

.tab-item-inactive {
  color: #999;
}

.rechange-title {
  box-sizing: border-box;
  height: 50px;
  margin: 35px auto 20px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background: #fdf6eb;
  border-radius: 4px;
  border: 1px solid #faa000;
  color: #333;
}

.content {
  padding: 20px 0;
  background: #f5f7fa;

  .content-left {
    width: 65%;
    padding: 20px;
    border-right: 1px solid #eee;

    .left-step {
      margin-bottom: 20px;
      text-align: left;
    }
  }

  .info-color {
    color: #407fff;
    font-size: 16px;
    margin-bottom: 15px;
  }

  .info-scan {
    color: #faa000;
  }

  .icon-step {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  .content-right {
    padding: 20px;

    .img-code {
      width: 200px;
      height: 200px;
    }
  }
}
</style>
